import {Team} from '../resources/Team';
import {DomainEvent} from './DomainEvent';

export abstract class TeamEvent extends DomainEvent<Team> {}
